/* Wellsons finish swatches
   Reads the finish map (Shopify Files: ws-finish-map.json) and renders BSD-style swatches on
   product cards (.ws-card[data-handle]) and on the product page (.tt-product-single-info).
   The map is rebuilt weekly; products not in it keep the swatches from the old metafield. */
(function () {
  'use strict';
  var MAP_URL = 'https://cdn.shopify.com/s/files/1/0495/7483/8429/files/ws-finish-map.json';
  var CARD_MAX = 7;

  function week() {
    var d = new Date(), s = new Date(d.getFullYear(), 0, 1);
    return d.getFullYear() + '-' + Math.ceil(((d - s) / 864e5 + s.getDay() + 1) / 7);
  }

  var mapPromise = null;
  function loadMap() {
    if (mapPromise) return mapPromise;
    mapPromise = fetch(MAP_URL + '?w=' + week())
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (!j || !j.families) return null;
        var idx = {};
        j.families.forEach(function (fam, i) {
          for (var k = 0; k < fam.length; k += 2) idx[fam[k]] = i;
        });
        return { idx: idx, families: j.families };
      })
      .catch(function () { return null; });
    return mapPromise;
  }

  /* Same rules as snippets/ws-finish-class.liquid, plus non-metal colours */
  function finishClass(name, vendor) {
    var n = (name || '').toLowerCase(), v = (vendor || '').toLowerCase();
    if (/champagne|rose gold/.test(n)) return 'champagne';
    if (/tiger bronze/.test(n)) return 'brushed-gold';
    if (/lustre bronze/.test(n)) return 'brushed-copper';
    if (/gun ?metal|shadow|graphite|anthracite/.test(n)) return 'gunmetal';
    if (/antique|aged brass/.test(n)) return 'antique-brass';
    if (/copper/.test(n)) return 'brushed-copper';
    if (/bronze|bonze/.test(n)) return v === 'meir' ? 'brushed-gold' : 'brushed-bronze';
    if (/brass|gold/.test(n)) return 'brushed-gold';
    if (/nickel/.test(n)) return (/warm/.test(n) || v === 'meir') ? 'warm-brushed-nickel' : 'brushed-nickel';
    if (/stainless|satin steel|aluminium|brushed$|brushed satin/.test(n)) return 'stainless-steel';
    if (/chrome|silver/.test(n)) return 'chrome';
    if (/walnut|black oak|sable|wenge|dark oak|ebony/.test(n)) return 'wood-dark';
    if (/oak|maple|birch|timber|bamboo|elm|ash|natural/.test(n)) return 'wood-light';
    if (/black|charcoal|onyx|coal/.test(n)) return 'matte-black';
    if (/terrazzo|concrete|cement|stone|marble|marmo|sandstone|mist/.test(n)) return 'concrete';
    if (/forest|green|tiffany/.test(n)) return 'forest';
    if (/sage|olive|khaki/.test(n)) return 'sage';
    if (/blue|navy|dusk|horizon/.test(n)) return 'blue';
    if (/pink|blush|lilac|clay|tuscan|terracotta/.test(n)) return 'pink';
    if (/beige|sand|latte|almond|taupe/.test(n)) return 'beige';
    if (/grey|gray|slate/.test(n)) return 'grey';
    if (/ivory|cream|warm white|bone|linen/.test(n)) return 'ivory';
    if (/gloss white/.test(n)) return 'gloss-white';
    if (/white/.test(n)) return 'matte-white';
    return 'other';
  }

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  /* family as [{h, f}], current product first */
  function ordered(map, handle) {
    var i = map.idx[handle];
    if (i === undefined) return null;
    var fam = map.families[i], cur = null, rest = [];
    for (var k = 0; k < fam.length; k += 2) {
      var it = { h: fam[k], f: fam[k + 1] };
      if (it.h === handle) cur = it; else rest.push(it);
    }
    return cur ? [cur].concat(rest) : null;
  }

  function swatchHtml(it, vendor, isCur, cls) {
    var c = finishClass(it.f, vendor), t = esc(it.f);
    return isCur
      ? '<span class="' + cls + ' wsx-sw--' + c + ' is-on" role="listitem" title="' + t + '" aria-label="' + t + ' (selected)"></span>'
      : '<a class="' + cls + ' wsx-sw--' + c + '" role="listitem" href="/products/' + esc(it.h) + '" title="' + t + '" aria-label="' + t + '"></a>';
  }

  /* ---------- Product cards ---------- */
  function renderCards(map, root) {
    var cards = (root || document).querySelectorAll('.ws-card[data-handle]:not([data-wsf])');
    for (var n = 0; n < cards.length; n++) {
      var card = cards[n];
      card.setAttribute('data-wsf', '1');
      var list = ordered(map, card.getAttribute('data-handle'));
      if (!list) continue;
      var vendor = card.getAttribute('data-vendor');
      var html = '';
      for (var k = 0; k < list.length && k < CARD_MAX; k++) html += swatchHtml(list[k], vendor, k === 0, 'wsx-fin');
      if (list.length > CARD_MAX) {
        html += '<a class="wsx-fin-more" href="/products/' + esc(list[0].h) + '">+' + (list.length - CARD_MAX) + '</a>';
      }
      var box = card.querySelector('.wsx-fins');
      if (!box) {
        box = document.createElement('div');
        box.className = 'wsx-fins';
        box.setAttribute('role', 'list');
        box.setAttribute('aria-label', 'Finishes');
        var price = card.querySelector('.ws-card__price');
        var info = card.querySelector('.ws-card__info') || card;
        if (price && price.parentNode) price.parentNode.insertBefore(box, price.nextSibling);
        else info.appendChild(box);
      }
      box.innerHTML = html;
    }
  }

  /* ---------- Product page ---------- */
  function renderPdp(map) {
    var info = document.querySelector('.tt-product-single-info');
    if (!info || info.querySelector('.wsx-pdp')) return;
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!m) return;
    var handle = decodeURIComponent(m[1]);
    var list = ordered(map, handle);
    if (!list) return;
    var vendorEl = document.querySelector('[data-ws-vendor]');
    var vendor = vendorEl ? vendorEl.getAttribute('data-ws-vendor') : '';
    var html = '<div class="wsx-pdp"><p class="wsx-pdp__label">Finish: <b>' + esc(list[0].f) + '</b>' +
      (list.length > 1 ? ' <span>· ' + list.length + ' finishes</span>' : '') + '</p><div class="wsx-pdp__row" role="list" aria-label="Finishes">';
    for (var k = 0; k < list.length; k++) html += swatchHtml(list[k], vendor, k === 0, 'wsx-pdp__sw');
    html += '</div></div>';
    var old = info.querySelector('.custom_swatches');
    var wrap = document.createElement('div');
    wrap.innerHTML = html;
    var block = wrap.firstChild;
    if (old) { old.parentNode.insertBefore(block, old); old.style.display = 'none'; }
    else {
      var add = info.querySelector('.tt-add-info') || info;
      add.appendChild(block);
    }
    /* hover preview of the finish name */
    var label = block.querySelector('.wsx-pdp__label b'), base = list[0].f;
    block.addEventListener('mouseover', function (e) { var a = e.target.closest('.wsx-pdp__sw'); if (a) label.textContent = a.title; });
    block.addEventListener('mouseleave', function () { label.textContent = base; });
  }

  function run() {
    loadMap().then(function (map) {
      if (!map) return;
      renderCards(map);
      renderPdp(map);
      if (window.MutationObserver) {
        new MutationObserver(function (muts) {
          for (var i = 0; i < muts.length; i++) {
            if (muts[i].addedNodes.length) { renderCards(map); break; }
          }
        }).observe(document.body, { childList: true, subtree: true });
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
